import { useState, useEffect, useCallback } from "react";
import {
  Stack,
  Title,
  Group,
  SimpleGrid,
  Paper,
  Text,
  Badge,
  Loader,
  Center,
  Button,
} from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

interface NameStat {
  _id: string;
  total: number;
  new: number;
  success: number;
  failed: number;
}

export default function AuditDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [names, setNames] = useState<NameStat[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    try {
      const res = await api.audit.names(id);
      setNames(res.data);
    } catch {
      // ignore
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  if (loading) {
    return (
      <Center h={400}>
        <Loader />
      </Center>
    );
  }

  return (
    <Stack gap="lg">
      <Group>
        <Button
          variant="subtle"
          leftSection={<IconArrowLeft size={16} />}
          onClick={() => navigate("/audit")}
        >
          Буцах
        </Button>
        <Title order={3}>Аудит дэлгэрэнгүй</Title>
      </Group>

      <SimpleGrid cols={{ base: 2, sm: 3, md: 4, lg: 6 }}>
        {names.map((n) => (
          <Paper
            key={n._id}
            withBorder
            p="md"
            radius="md"
            onClick={() => navigate(`/audit/${id}/${n._id}`)}
            style={{ cursor: "pointer" }}
          >
            <Group justify="space-between" mb="xs">
              <Text fw={700} size="lg">
                {n._id}
              </Text>
              <Badge variant="light">{n.total}</Badge>
            </Group>
            <Group gap="xs">
              <Badge color="gray" size="xs" variant="light">
                Шинэ: {n.new}
              </Badge>
              <Badge color="green" size="xs" variant="light">
                Зөв: {n.success}
              </Badge>
              <Badge color="red" size="xs" variant="light">
                Буруу: {n.failed}
              </Badge>
            </Group>
          </Paper>
        ))}
      </SimpleGrid>

      {names.length === 0 && (
        <Text ta="center" c="dimmed" py="lg">
          Аудит зураг олдсонгүй
        </Text>
      )}
    </Stack>
  );
}
